import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RequestUserStatus } from '../../../../model/enum/request-user-status.enum';
import { VerificationHistory } from '../../../../model/cpl-verification-history.model';
import { RequestVerificationStatus } from '../../../enums/verification-status.enum';
import { IndicatorStyle } from '../../../../components/enums/indicator-style.enum';
import { IndicatorIcon } from '../../../../components/enums/indicator-icon.enum';
import { StateService } from '@uirouter/core';
import { CplItemType } from 'src/app/model/enum/cpl-item-type.enum';

export const DEFAULT_VERIFICATION_NAME = 'Comply'
@Component({
    selector:    'user-request-history-item',
    templateUrl: './request-history-item.component.html'
})
export class UserRequestHistoryItemComponent {
    @Input() historyItem: VerificationHistory;

    @Output() onMessagesClicked = new EventEmitter<string>();

    RequestUserStatus = RequestUserStatus;

    constructor(private stateService: StateService)
    {}

    getActionText(historyItem:VerificationHistory){
        const verificationByName = historyItem?.VerificationByName ?? DEFAULT_VERIFICATION_NAME

        switch (historyItem.VerificationStatus) {
            case RequestVerificationStatus.SUBMITTED :
                return `Submitted by ${verificationByName}`;
            case RequestVerificationStatus.APPROVED:
                return `Approved by ${verificationByName}`;
            case RequestVerificationStatus.COMPLETED:
                return "Request completed";
            case  RequestVerificationStatus.REQUEST_APPROVED:
                return "Request approved";
            case  RequestVerificationStatus.FOLLOWUP_REQUESTED:
                return `Follow-Up initiated by ${verificationByName}`;
            case RequestVerificationStatus.FOLLOWUP_DUE_DATE_CHANGED:
                return `Follow-Up Due Date changed by ${verificationByName}`;
            case  RequestVerificationStatus.FOLLOWUP_SUBMITTED:
                return `Follow-Up submitted by ${verificationByName}`;
            case  RequestVerificationStatus.FOLLOWUP_APPROVED:
                return `Follow-Up approved`;
            case  RequestVerificationStatus.CANCELLED:
                return `Request cancelled by ${verificationByName}`;
            case  RequestVerificationStatus.DISAPPROVED:
                return `Request disapproved by ${verificationByName}`;
            case RequestVerificationStatus.FOLLOWUP_DISAPPROVED:
                return `Follow-Up disapproved by ${verificationByName}`;
            case RequestVerificationStatus.REOPEN:
                return  `Request reopened by ${verificationByName}`;
            case RequestVerificationStatus.FOLLOWUP_REOPENED:
                return  `Follow-Up reopened by ${verificationByName}`;
            case RequestVerificationStatus.FOLLOWUP_FORGIVEN:
                return  `Follow-Up forgiven by ${verificationByName}`;
            case RequestVerificationStatus.SKIPPED:
                return `Bypass Approval Stage - ${historyItem.StageName}`;
            case RequestVerificationStatus.CHANGE_MANAGER:
                return `Manager changed to ${historyItem.TargetUserName}`;
            case RequestVerificationStatus.NUDGED:
                return `Nudged by ${verificationByName}`;
            case RequestVerificationStatus.MESSAGE:
                return `Messaged by ${verificationByName}`;
            default :
                return "";
        }
           
    }

    getStatusStyle(statusId: number) {
        switch(statusId) {
            case RequestVerificationStatus.REOPEN:
            case RequestVerificationStatus.FOLLOWUP_REOPENED:
            case RequestVerificationStatus.CHANGE_MANAGER:
                return IndicatorStyle.STEP_REOPENED;
            case RequestVerificationStatus.APPROVED:
            case RequestVerificationStatus.REQUEST_APPROVED:
            case RequestVerificationStatus.FOLLOWUP_APPROVED:
                return IndicatorStyle.STEP_APPROVED;
            case RequestVerificationStatus.COMPLETED:
                return IndicatorStyle.STEP_COMPLETED;
            case RequestVerificationStatus.SUBMITTED:
            case RequestVerificationStatus.FOLLOWUP_SUBMITTED:
                return IndicatorStyle.STEP_SUBMITTED;
            case RequestVerificationStatus.DISAPPROVED:
            case RequestVerificationStatus.FOLLOWUP_DISAPPROVED:
                return IndicatorStyle.DECLINED;
            case RequestVerificationStatus.FOLLOWUP_FORGIVEN:
                return IndicatorStyle.FORGIVEN;
            case RequestVerificationStatus.NUDGED:
                return IndicatorStyle.NUDGED;
            case RequestVerificationStatus.MESSAGE:
                return IndicatorStyle.MESSAGE;
            case RequestVerificationStatus.FOLLOWUP_DUE_DATE_CHANGED:
                return IndicatorStyle.DUE_DATE_CHANGED;
            default:
                return IndicatorStyle.NONE;
        }
    }

    getStatusIcon(statusId: number) {
        switch(statusId) {
            case RequestVerificationStatus.SKIPPED:
                return IndicatorIcon.FAST_FORWARD;
            case RequestVerificationStatus.SUBMITTED:
            case RequestVerificationStatus.FOLLOWUP_SUBMITTED:
            case RequestVerificationStatus.REOPEN:
            case RequestVerificationStatus.FOLLOWUP_REOPENED:
                return IndicatorIcon.INBOX;
            case RequestVerificationStatus.FOLLOWUP_REQUESTED:
            case RequestVerificationStatus.FOLLOWUP_DUE_DATE_CHANGED:
                return IndicatorIcon.CALENDAR;
            case RequestVerificationStatus.APPROVED:
            case RequestVerificationStatus.FOLLOWUP_APPROVED:
            case RequestVerificationStatus.REQUEST_APPROVED:
            case RequestVerificationStatus.COMPLETED:
                return IndicatorIcon.CHECK;
            case RequestVerificationStatus.DISAPPROVED:
            case RequestVerificationStatus.FOLLOWUP_DISAPPROVED:
                return IndicatorIcon.TIMES;
            case RequestVerificationStatus.CANCELLED:
                return IndicatorIcon.MINUS;
            case RequestVerificationStatus.FOLLOWUP_FORGIVEN:
                return IndicatorIcon.ASTERISK;
            case RequestVerificationStatus.CHANGE_MANAGER:
                return IndicatorIcon.USER; 
            case RequestVerificationStatus.NUDGED:
                return IndicatorIcon.POINT;
            case RequestVerificationStatus.MESSAGE:
                return IndicatorIcon.MESSAGE;
            default:
                return IndicatorIcon.NONE;
        }
    }

    messageClicked(requestHistoryId: string) {
        this.onMessagesClicked.emit(requestHistoryId);

        this.stateService.go('authenticated.messages.history', {
            historyId: requestHistoryId,
            typeId: CplItemType.REQUEST,
            page: 1
        });
    }
}